<Cell {header} {priority} type="text" {colspan} {rowspan}>
    <span slot="header">
        <span class:screen-reader={headerHidden}>{text}</span>
    </span>
    <span slot="data">
        <span class="prom-text-cell--{textStyle}">
            {text}
        </span>
        <span>{detail}</span>
    </span>
</Cell>

<script>
    import Cell from '../../Cell/v1/Cell.svelte';

    /** @type {string} */
    export let text = '';
    /** @type {string} */
    export let detail = '';
    /** @type {string} */
    export let textStyle = 'plain';
    /** @type {boolean} */
    export let header = false;
    /** @type {1|2|3} */
    export let priority = 1;
    /** @type {boolean} */
    export let headerHidden = false;
    /** @type {number} */
    export let colspan = 1;
    /** @type {number} */
    export let rowspan = 1;
</script>
